var _defs, _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurprised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "base",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 339.42 347.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #3d3327;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 14px;\n      }\n      .cls-2 {\n        fill: #5d3233;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434,233.05s54.05-35.8,119.33,14.31",
    transform: "translate(-220.92 -213.66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.92,254.22s42-49.39,118.61-19.36",
    transform: "translate(-220.92 -213.66)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 169.08,
    cy: 286.34,
    rx: 67,
    ry: 61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprised);
export default __webpack_public_path__ + "static/media/surprised.af07365c.svg";
export { ForwardRef as ReactComponent };